import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// online
const firebaseConfig = {
  apiKey: "AIzaSyDEe8L_LIqtl1K6oz7Wu9wWWTnmrsHHXF8",
  authDomain: "cozytaps-f935d.firebaseapp.com",
  projectId: "cozytaps-f935d",
  storageBucket: "cozytaps-f935d.firebasestorage.app",
  messagingSenderId: "395430504581",
  appId: "1:395430504581:web:c52206fe7fc27bddb9e1ec"
};

// pre
// const firebaseConfig = {
//   apiKey: "AIzaSyCKEgCi6rdku_HYocf11jcBNGvaNNFBKwk",
//   authDomain: "papibangpre.firebaseapp.com",
//   projectId: "papibangpre",
//   storageBucket: "papibangpre.firebasestorage.app",
//   messagingSenderId: "473132553985",
//   appId: "1:473132553985:web:cc434187e2f337a9fead00",
//   measurementId: "G-VJ5VY5GVEB"
// };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default {
  app,
  auth
};